export default __webpack_public_path__ + "images/GV.27b6cba.png";